import React, { Fragment, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import {
  FirstName,
  LastName,
  Submit,
  Cancel,
  BirthDate,
  Age,
  MobileNo,
  ContactNo,
  ContactRelation,
  Gender,
  Address,
} from "../../../../Constant";
import RequiredField from "../../../../Constant";
import { Breadcrumbs } from "../../../../AbstractElements";
import { useNavigate, useLocation } from "react-router";
import { toast } from "react-toastify";
import { CreatePatient, UpdatePatient } from "../../../../apiController";

const PatientForm = ({ setSteps }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formdata, setFormdata] = useState({});
  const [base64, setBase64] = useState("");

  const { rowData } = location.state || {};

  const {
    control,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const [age, setAge] = useState("");

  const dob = watch("birthday");

  useEffect(() => {
    if (rowData?.dob) {
      reset({
        // phone: rowData.phone,
        // birthday: rowData.dob,
        image: rowData.image,
        firstName: rowData.first_name,
        lastname: rowData.surname,
        email: rowData.email,
        regno: rowData.patient_reg_no,
        birthday: rowData.dob,
        age: rowData.age,
        phone: rowData.phone,
        gender: rowData.gender,
        profession: rowData.profession,
        contactname: rowData.primary_contact_name,
        relation: rowData.relationship,
        contactnumber: rowData.contact_mobile,
        address: rowData.address,
        id: rowData.id,
      });
    }
  }, [rowData, reset]);

  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dobDate.getDate())
      ) {
        age--;
      }
      setAge(age);
      setValue("age", age);
    }
  }, [dob, setValue]);
  const onSubmit = async (data) => {
    // console.log(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    console.log(data);

    const formattedData = {
      image: data.image,
      first_name: data.firstName,
      surname: data.lastname,
      patient_reg_no: data.regno,
      phone: data.phone,
      email: data.email,
      age: data.age,
      dob: data.birthday,
      gender: data.gender,
      profession: data.profession,
      primary_contact_name: data.contactname,
      relationship: data.relation,
      contact_mobile: data.contactnumber,
      address: data.address,
      id: rowData ? rowData.id : "",
    };
    console.log(formattedData);
    try {
      if (rowData) {
        const response = await UpdatePatient(formattedData);
        if (response.status === true) {
          toast.success("Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        navigate(`${process.env.PUBLIC_URL}/patientList/:layout>}`);
      } else {
        const response = await CreatePatient(formattedData);
        if (response.status === true) {
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (response.status === false) {
          toast.error(response.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        navigate(`${process.env.PUBLIC_URL}/patientList/:layout>}`);
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    reset();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
        setValue("image", reader.result); // Set base64 string in form
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Patient"
        mainTitle="Patient Form"
        title="Patient Form"
      />
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-bookmark needs-validation"
      >
        <Row>
          <Col sm="12" xl="6" className="custom-padding-lg">
          {!rowData && (
                <FormGroup className="mb-3">
                  {!base64 && (
                    <>
                      <Label htmlFor="fname">{"Image"}</Label>
                      <input
                        className={`form-control ${
                          errors.image && "is-invalid"
                        }`}
                        id="image"
                        type="file"
                        name="firstname"
                        accept=".jpg, .jpeg, .png"
                        defaultValue={formdata.image || ""}
                        {...register("image", { required: false })}
                        onChange={handleFileChange}
                      />
                      <span className="text-danger">
                        {errors.image && "Image is required"}
                      </span>
                    </>
                  )}
                  {base64 && (
                    <div>
                      <img
                        src={base64}
                        alt="Selected"
                        style={{ maxWidth: "100px", maxHeight: "100px" }}
                      />
                    </div>
                  )}
                </FormGroup>
              )}
            <FormGroup className="mb-3">
              <Label htmlFor="fname">
                {FirstName} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.firstName && "is-invalid"}`}
                id="fname"
                type="text"
                name="firstname"
                defaultValue={formdata.firstName || ""}
                {...register("firstName", { required: true })}
              />
              <span className="text-danger">
                {errors.firstName && "First name is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="lname">
                {LastName} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.lastname && "is-invalid"}`}
                id="lname"
                type="text"
                name="lastname"
                defaultValue={formdata.lastname || ""}
                {...register("lastname", { required: true })}
              />
              <span className="text-danger">
                {errors.lastname && "Last name is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">
                {MobileNo} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.age && "is-invalid"}`}
                id="phone"
                type="number"
                name="phone"
                defaultValue={formdata.phone || ""}
                {...register("phone", { required: true })}
              />
              <span className="text-danger">
                {errors.age && "Age is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="Bdate">
                {BirthDate} <RequiredField />
              </Label>
              <Controller
                control={control}
                name="birthday"
                render={({ field }) => (
                  <input
                    {...field}
                    className={`form-control ${
                      errors.birthday && "is-invalid"
                    }`}
                    id="Bdate"
                    type="date"
                    max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                  />
                )}
              />
              <span className="text-danger">
                {errors.birthday && "Birth Date is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="age">
                {Age} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.age && "is-invalid"}`}
                id="age"
                type="number"
                name="age"
                value={age}
                disabled
              />
              <span className="text-danger">
                {errors.age && "Age is required"}
              </span>
            </FormGroup>
            {/* <FormGroup className="mb-3">
              <Label htmlFor="Bdate">
                {BirthDate} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.birthday && "is-invalid"}`}
                id="Bdate"
                type="date"
                name="birthday"
                defaultValue={formdata.birthday || ""}
                {...register("birthday", { required: true })}
              />
              <span className="text-danger">
                {errors.birthday && "Birth Date is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="age">
                {Age}
                <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.age && "is-invalid"}`}
                id="age"
                type="number"
                name="age"
                defaultValue={formdata.age || ""}
                {...register("age", { required: true })}
              />
              <span className="text-danger">
                {errors.age && "Age is required"}
              </span>
            </FormGroup> */}
            <FormGroup>
                <Label htmlFor="gender">
                  Gender <RequiredField />
                </Label>
                <div className="d-flex gap-3">
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <Input
                            className="custom-control-input"
                            id="male"
                            type="radio"
                            value={
                              rowData?.gender === "male" ? rowData?.gender : ""
                            }
                            checked={field.value === "male"}
                            onChange={() => field.onChange("male")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="male"
                          >
                            Male
                          </Label>
                        </>
                      )}
                    />
                  </div>
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <Input
                            className="custom-control-input"
                            id="female"
                            type="radio"
                            value={
                              rowData?.gender === "female"
                                ? rowData?.gender
                                : ""
                            }
                            checked={field.value === "female"}
                            onChange={() => field.onChange("female")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="female"
                          >
                            Female
                          </Label>
                        </>
                      )}
                    />
                  </div>
                </div>
              </FormGroup>
            {/* <FormGroup className="mb-3">
              <Label htmlFor="gender">
                {Gender} <RequiredField />
              </Label>
              <div className="mt-2 d-flex gap-3">
                <div className="custom-control form-check custom-radio">
                  <Input
                    className="custom-control-input"
                    id="customControlValidation2"
                    type="radio"
                    name="radio-stacked"
                    required
                  />
                  <Label
                    className="custom-control-label"
                    htmlFor="customControlValidation2"
                  >
                    {"Male"}
                  </Label>
                </div>
                <div className="custom-control form-check custom-radio mb-3">
                  <Input
                    className="custom-control-input"
                    id="customControlValidation3"
                    type="radio"
                    name="radio-stacked"
                    required
                  />
                  <Label
                    className="custom-control-label"
                    htmlFor="customControlValidation3"
                  >
                    {"Female"}
                  </Label>
                  <div className="invalid-feedback">
                    {"More example invalid feedback text"}
                  </div>
                </div>
              </div>
            </FormGroup> */}
            <FormGroup className="mb-3">
              <Label htmlFor="regno">
                {"Register Number (Format: WT-P000X)"} <RequiredField />
              </Label>
              <input
                className={`form-control ${errors.regno && "is-invalid"}`}
                id="regno"
                type="text"
                name="regno"
                defaultValue={formdata.regno || ""}
                {...register("regno", { required: true })}
              />
              <span className="text-danger">
                {errors.regno && "Register Number is required"}
              </span>
            </FormGroup>
          </Col>
          <Col sm="12" xl="6" className="custom-padding-lg mb-3">
            <FormGroup className="mb-3">
              <Label htmlFor="address">{Address}</Label>
              <Input
                type="textarea"
                className="form-control"
                rows="3"
                id="address"
                name="address"
                defaultValue={formdata.address || ""}
                {...register("address", { required: false })}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="email">"Email Address"</Label>
              <input
                className={`form-control ${errors.email && "is-invalid"}`}
                id="email"
                type="email"
                name="email"
                defaultValue={formdata.email || ""}
                {...register("email", { required: false })}
              />
              {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="profession">{"Profession"}</Label>
              <input
                className={`form-control ${errors.profession && "is-invalid"}`}
                id="profession"
                type="text"
                name="profession"
                defaultValue={formdata.profession || ""}
                {...register("profession", { required: false })}
              />
              <span className="text-danger">
                {errors.profession && "profession is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Relation Contact Name"}</Label>
              <input
                className={`form-control ${errors.contactName && "is-invalid"}`}
                id="contactname"
                type="text"
                name="contactname"
                defaultValue={formdata.contactname || ""}
                {...register("contactname", { required: false })}
              />
              <span className="text-danger">
                {errors.contactname && "Realation Contact Name is required"}
              </span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="relation">{ContactRelation}</Label>
              <input
                className={`form-control ${errors.relation && "is-invalid"}`}
                id="relation"
                type="text"
                name="relation"
                defaultValue={formdata.relation || ""}
                {...register("relation", { required: false })}
              />
              {/* <span className="text-danger">{errors.firstName && "First name is required"}</span> */}
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="contactnumber">{ContactNo}</Label>
              <input
                className={`form-control ${
                  errors.contactnumber && "is-invalid"
                }`}
                id="contactnumber"
                type="number"
                name="contactnumber"
                defaultValue={formdata.contactnumber || ""}
                {...register("contactnumber", { required: false })}
              />
              {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
            </FormGroup>
            <div className="text-end btn-mb">
              <Button
                className="secondary me-2"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/patientList/:layout>}`)
                }
              >
                {Cancel}
              </Button>
              <Button className="primary" type="submit">
                {Submit}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default PatientForm;
